import React from 'react';
import { Link } from 'react-router-dom';

export interface ServiceCardProps {
  to: string;
  title: string;
  description: React.ReactNode;
  tags?: string[];
  icon: React.ReactNode;
  ctaLabel?: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  to,
  title,
  description,
  tags,
  icon,
  ctaLabel = 'open spec',
}) => (
  <Link to={to} className="svc">
    <div className="svc__top">
      <span className="svc__glyph" aria-hidden="true">
        {icon}
      </span>
    </div>
    <h3>{title}</h3>
    <p>{description}</p>
    {tags && tags.length > 0 && (
      <div className="svc__tags">
        {tags.map(t => (
          <span key={t}>{t}</span>
        ))}
      </div>
    )}
    <span className="svc__cta">
      {ctaLabel}
      <svg width={10} height={10} viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth={1.5}>
        <path d="M2 5h6M5 2l3 3-3 3" />
      </svg>
    </span>
  </Link>
);

export default ServiceCard;
